import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import DownloadButton from './DownloadButton';
import './Attachment.css';

const MultimediaAttachment = ({
  attachment: { url, key, type },
  originalFilename,
  ...props
}) => {
  return (
    <div className='multimedia-container'>
      <div style={{ margin: 8 }}>
        <div className='multimedia-header-container'>
          <Typography type='bold' style={{ flex: 1, fontSize: '0.825rem', marginRight: 8 }}>{originalFilename}</Typography>
          <DownloadButton attachment={{ url, key, type }} />
        </div>
        { props.children }
      </div>
    </div>
  );
};

MultimediaAttachment.propTypes = {
  attachment: PropTypes.shape({
    url: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string
  }),
  originalFilename: PropTypes.string
};

export default MultimediaAttachment;
